import { Flex, theme } from '@aloft/toolkit-sui';

import { selectAivArvActiveTab } from '../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { PROPERTY_HEADER_COLOR_BAND_HEIGHT, PROPERTY_HEADER_IMAGE_HEIGHT } from '../consts.ts';
import { getTabBackgroundColor } from '../utils.ts';

type LabelColumnHeaderSectionProps = {
  content: React.ReactNode;
};

export const LabelColumnHeaderSection = ({ content }: LabelColumnHeaderSectionProps) => {
  const activeTab = useAppSelector(selectAivArvActiveTab);
  const backgroundColor = getTabBackgroundColor(activeTab);

  return (
    <Flex
      position="sticky"
      top="0"
      zIndex={theme.zIndices.sticky}
      backgroundColor={backgroundColor}
      width="100%"
      height={`calc(${PROPERTY_HEADER_IMAGE_HEIGHT} + ${PROPERTY_HEADER_COLOR_BAND_HEIGHT} + 1px)`}
      __dangerDoNotUseSx={{ borderBottom: `1px solid ${theme.colors.strokeDefault}` }}
    >
      {content}
    </Flex>
  );
};
